import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold mt-10 mb-4" }
const _hoisted_2 = { class: "space-y-4 text-sm" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("education")), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.education, (edu, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(edu.school), 1),
          _createElementVNode("p", null, _toDisplayString(edu.degree), 1),
          (edu.details)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(edu.details), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}